// there shouldn't be a problem with not checking event here
// since we can only hit this action from the refresh actor
// onDone or onError
export function unsetRefreshToken() {
  return {
    refreshToken: '',
  };
}

export default unsetRefreshToken;
